export const LEGAL_CONTENT = {
  about: {
    title: "Sobre o BoraConverter",
    content: `
      <p>O <strong>BoraConverter</strong> foi criado para resolver uma necessidade frequente: converter imagens com rapidez, sem instalar software e sem enviar arquivos para servidores externos.</p>

      <h3>Nosso objetivo</h3>
      <p>Oferecer uma ferramenta gratuita, simples e útil para profissionais de marketing, design, desenvolvimento e pequenos negócios que precisam adaptar imagens para diferentes plataformas.</p>

      <h3>Como funciona</h3>
      <p>A conversão ocorre localmente no navegador, usando recursos do próprio dispositivo. Isso reduz tempo de espera e reforça a privacidade no uso diário.</p>

      <h3>Para quem foi feito</h3>
      <p>O BoraConverter atende, principalmente, quem trabalha com sites, e-commerce, redes sociais e aplicativos e precisa converter formatos como WebP, PNG, JPG e ICO com frequência.</p>

      <h3>Atendimento</h3>
      <p>Nosso canal de atendimento está em fase de implantação. Enquanto isso, seguimos focados em evoluir a ferramenta e publicar guias práticos de qualidade.</p>
    `,
  },
  privacy: {
    title: "Política de Privacidade",
    content: `
      <p>Esta Política de Privacidade explica como os dados são tratados no BoraConverter.</p>

      <h3>1. Processamento local de imagens</h3>
      <p>As imagens enviadas para conversão são processadas no navegador. Não armazenamos arquivos em banco de dados nem em servidor de aplicação.</p>

      <h3>2. Cookies e publicidade</h3>
      <p>Podemos exibir anúncios por meio do Google AdSense. O Google pode usar cookies para personalização e medição de anúncios. Você pode gerenciar suas preferências em <a href="https://adssettings.google.com" target="_blank" rel="noreferrer">adssettings.google.com</a>.</p>

      <h3>3. Métricas de uso</h3>
      <p>Utilizamos métricas agregadas para entender o desempenho do site, como páginas acessadas e tempo médio de permanência. Essas informações ajudam a melhorar a experiência.</p>

      <h3>4. Links externos</h3>
      <p>Podemos incluir links para serviços de terceiros. Cada serviço possui política própria, e não controlamos suas práticas.</p>

      <h3>5. Atendimento sobre privacidade</h3>
      <p>Solicitações relacionadas à privacidade serão atendidas por canal oficial assim que a estrutura de atendimento for finalizada.</p>
    `,
  },
  terms: {
    title: "Termos de Uso",
    content: `
      <p>Ao utilizar o BoraConverter, você concorda com os termos abaixo.</p>

      <h3>1. Uso da ferramenta</h3>
      <p>O uso é gratuito para fins pessoais e profissionais, respeitando as leis aplicáveis e os direitos de terceiros sobre os arquivos convertidos.</p>

      <h3>2. Disponibilidade</h3>
      <p>Buscamos manter o serviço estável, mas não garantimos funcionamento ininterrupto em todos os dispositivos, navegadores ou cenários de rede.</p>

      <h3>3. Limitação de responsabilidade</h3>
      <p>O usuário é responsável por manter cópias de segurança de seus arquivos. Não nos responsabilizamos por perdas indiretas decorrentes do uso da ferramenta.</p>

      <h3>4. Atualizações</h3>
      <p>Podemos atualizar funcionalidades e estes termos para refletir melhorias técnicas, operacionais ou legais.</p>

      <h3>5. Atendimento</h3>
      <p>Nosso canal oficial de atendimento está em implantação e será divulgado no próprio site quando estiver disponível.</p>
    `,
  },
};